module.exports = __webpack_public_path__ + "0087c090d4a9a5b902f890535eabfdfe.svg";